import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BasisTheoryProvider } from './components/basis-theory/basis-theory-provider'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'sonner'
import { ThemeProvider } from './components/theme-provider'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import AppRouter from './router'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

function App() {
  return (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider defaultTheme="light" storageKey="hpp-ui-theme">
          <BasisTheoryProvider>
            <QueryClientProvider client={queryClient}>
              <AppRouter />
              <Toaster position="top-right" />
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </BasisTheoryProvider>
        </ThemeProvider>
      </I18nextProvider>
    </HelmetProvider>
  )
}

export default App
